import request from '@/utils/request'
//获取table表格数据
export function getList (data) {
  return request({
    url: `/teacherFeedback/page`,
    method: 'post',
    data,
  })
}





export function getList1 (data) {
  return request({
    url: `/teacherFeedback/pageFamily`,
    method: 'post',
    data,
  })
}



export function getLists (data) {
  return request({
    url: `/firstFeedback/page`,
    method: 'post',
    data,
  })
}

//获取所有老师
export function getTeachers () {
  return request({
    url: `schedule/teacherDiagnosisList`,
    method: 'get',
  })
}
//获取所有学生
export function getStudents () {
  return request({
    url: `student/getStudentList`,
    method: 'get',
  })
}

export function getStudentsType (type) {
  return request({
    url: `student/getStudentList`,
    method: 'post',
    data:{
      studentType: type,
    }
  })
}

//修改首次课成功情况
export function changeFirstClass (data) {
  return request({
    url: `/firstRecord/update`,
    method: 'post',
    data
  })
}
//修改销售完成情况
export function markeStatus (data) {
  return request({
    url: `/teacherFeedback/update`,
    method: 'post',
    data: {
      id: data.id,
      marketSuccess: data.marketSuccess,
      url: data.url,
    }
  })
}
export function markeStatuss (data) {
  return request({
    url: `/firstFeedback/accomplish`,
    method: 'post',
    data: {
      id: data.id,
      marketSuccess: data.marketSuccess,
      url: data.url,
    }
  })
}
//获取所有科目
export function getSubject () {
  return request({
    url: `schedule/categorylist`,
    method: 'get',
  })
}
//详情
export function getdeta (id) {
  return request({
    url: `/teacherFeedback/detail/${id}`,
    method: 'get',
  })
}
//一键计算
export function count () {
  return request({
    url: `/teacherFeedback/calculate`,
    method: 'get',
  })
}
//获取教师课后反馈提醒数据
export function getNum () {
  return request({
    url: `/teacherFeedback/total`,
    method: 'get',
  })
}

//详情确定按钮
export function determine (data) {
  return request({
    url: `/teacherFeedback/lesson/${data.id}`,
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/feedBackApi.js